import React from "react"

const ProjectRouteContext = React.createContext<ProjectRouteContextValue | undefined>(undefined)
export const ProjectRouteContextProvider = ProjectRouteContext.Provider

export const useProjectRouteContext = () => {
  const context = React.useContext(ProjectRouteContext)
  if (!context) {
    throw new Error("useProjectRouteContext must be used within a ProjectRouteContext.Provider")
  }
  return context
}

type ProjectRouteContextValue = {
  isActualBarShown: boolean
  toggleActualBar: () => void
  isBaselineBarShown: boolean
  toggleBaselineBar: () => void
  isFullScreen: boolean
  toggleFullscreen: () => void
}
